"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBarV2 = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const ButtonV2_1 = require("../ButtonV2");
const TextField_1 = require("../TextField/TextField");
const SearchBarV2 = (_a) => {
    var { onClickSearch, disabled } = _a, props = __rest(_a, ["onClickSearch", "disabled"]);
    const searchIcon = react_1.default.useCallback(() => (react_1.default.createElement(ButtonV2_1.ButtonV2, { icon: "magnifying-glass", "aria-label": "Search", disabled: disabled, onClick: onClickSearch })), [disabled, onClickSearch]);
    return (react_1.default.createElement(foundations_1.Box, { sx: { position: "relative" } },
        react_1.default.createElement(TextField_1.TextField, Object.assign({ searchIcon: searchIcon, onEnter: onClickSearch, disabled: disabled }, props))));
};
exports.SearchBarV2 = SearchBarV2;
//# sourceMappingURL=SearchBarV2.js.map